import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

import { ApiService } from '@api/service';
import { WhoAmI$Response } from '@api/types';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppService {
  private defaultState: WhoAmI$Response = null;
  private state: WhoAmI$Response = this.defaultState;
  private appSubject: Subject<WhoAmI$Response> = new BehaviorSubject<
    WhoAmI$Response
  >(this.state);

  constructor(private api: ApiService) {}

  setState(newState: WhoAmI$Response) {
    this.state = { ...this.state, ...newState };
    this.appSubject.next(this.state);
  }

  getState() {
    return this.appSubject;
  }

  getWhoAmI(forceFetch: boolean = false): void {
    this.api.user
      .whoAmI()
      .pipe(tap(whoAmI => this.setState(whoAmI)))
      .subscribe();
  }
}
